import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api'
import { qk } from '../../lib/query'
import { useUi } from '../../state/UiContext'
import { Icon } from '../icons'
import { CustomerTab } from './CustomerTab'
import { ProductsTab } from './ProductsTab'
import { TicketsTab } from './TicketsTab'

// Cliente now carries the orders too — they were a separate tab, which split the two things an
// agent always reads together.
const TABS: [string, string][] = [
  ['cliente', 'Cliente'],
  ['produtos', 'Produtos'],
  ['tickets', 'Tickets'],
]

export function ContextPanel({
  conversationId,
  agents,
}: {
  conversationId: string
  agents: { id: string; name: string; avatarColor: string }[]
}) {
  const { state, dispatch } = useUi()
  const { data: conv } = useQuery({
    queryKey: qk.conversation(conversationId),
    queryFn: () => api.conversation(conversationId),
  })
  const { data: orders } = useQuery({
    queryKey: qk.customerOrders(conv?.customerId ?? ''),
    queryFn: () => api.customerOrders(conv!.customerId),
    enabled: !!conv,
  })

  if (!conv) return <aside className="ctx" />

  return (
    <aside className={`ctx ${state.ctxOpen ? 'open' : ''}`}>
      <div className="ctx-tabs">
        {/* Only shown while the panel is a drawer. It opens from a button in the conversation
            header — which the drawer then covers — so without this there is no way back. */}
        <button
          className="icon-btn ctx-close-btn"
          onClick={() => dispatch({ type: 'toggleCtx' })}
          title="Fechar"
          aria-label="Fechar painel"
        >
          <Icon name="x" size={15} />
        </button>
        {TABS.map(([k, label]) => (
          <button
            key={k}
            className={`ctab2 ${state.ctxTab === k ? 'on' : ''}`}
            onClick={() => dispatch({ type: 'setCtxTab', tab: k as never })}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="ctx-body">
        {state.ctxTab === 'cliente' && <CustomerTab conv={conv} />}
        {state.ctxTab === 'produtos' && <ProductsTab conversationId={conv.id} />}
        {state.ctxTab === 'tickets' && (
          <TicketsTab conv={conv} agents={agents} orders={orders?.map((o) => ({ id: o.id, externalOrderId: o.externalOrderId })) ?? []} />
        )}
      </div>
    </aside>
  )
}
